import React, { useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./components/Layout";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Routing from "./components/Routes";
import LoginForm from "./components/Onboarding/LoginForm";
import { AuthProvider } from "./components/Context/authContext";
import { RouterContextProvider } from "./components/Common/useRouterContext";
import { CompanyProvider } from "./components/Context/companyContext";
import {
  BrainstormProvider,
  brainstormPublicRoute,
} from "./brainstormStudio";
import "@ameetjha26/brainstorm-studio/style.css";
import axiosInstance from "./utils/api";
import BrainstormReadyGate from "./components/Brainstorm/BrainstormReadyGate";

function parseAgentIntegrations() {
  try {
    return JSON.parse(localStorage.getItem("agent_integrations") || "{}");
  } catch {
    return {};
  }
}

function App() {
  useEffect(() => {
    console.log("[Productive] App boot", {
      env: process.env.NODE_ENV,
      apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://api.produc8ive.com",
      brainstormStudio: true,
      buildTag: "brainstorm-v1",
    });
  }, []);

  return (
    <Router>
      <RouterContextProvider>
        <AuthProvider>
          <CompanyProvider>
            <BrainstormProvider
              apiClient={axiosInstance}
              getChatAgentId={() => {
                const j = parseAgentIntegrations();
                return j.chat_agent || j.Chat_agent || j.brainstorm_chat_agent || null;
              }}
              getDim3FolderId={() =>
                parseAgentIntegrations().knowledge_base_dim3_folder_id || null
              }
              getUserId={() =>
                localStorage.getItem("user_id") || localStorage.getItem("userId")
              }
            >
              <ToastContainer position="top-right" autoClose={3000} />
              <BrainstormReadyGate>
                <Routes>
                  <Route path="/login" element={<LoginForm />} />
                  {brainstormPublicRoute}
                  <Route
                    path="/*"
                    element={
                      <Layout>
                        <Routing />
                      </Layout>
                    }
                  />
                </Routes>
              </BrainstormReadyGate>
            </BrainstormProvider>
          </CompanyProvider>
        </AuthProvider>
      </RouterContextProvider>
    </Router>
  );
}

export default App;
